import { Injectable } from '@angular/core';
import { RoleValidatorService } from './role-validators.service';

@Injectable({ providedIn: 'root' })
export class AccessControlService {
  constructor(
    private readonly roleValidator: RoleValidatorService,
  ) {}


  canAccessSystem(): boolean {
    const validators = [
      this.roleValidator.validate()
    ];

    return validators.every(v => v === true);
  }
}
